import { DateTime, DateTimeUnit } from 'luxon';

declare module 'luxon' {
  interface DateTime {
    midnightEndOf(unit: DateTimeUnit): DateTime;
  }
}

DateTime.prototype.midnightEndOf = function (unit: DateTimeUnit): DateTime {
  const self = this as DateTime;
  return self.endOf(unit).plus({ millisecond: 1 });
};
